import { render, staticRenderFns } from "./BaseSliderScrollbar.vue?vue&type=template&id=a7c3dd24&scoped=true&"
import script from "./BaseSliderScrollbar.vue?vue&type=script&lang=js&"
export * from "./BaseSliderScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./BaseSliderScrollbar.vue?vue&type=style&index=0&id=a7c3dd24&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c3dd24",
  null
  
)

export default component.exports